import type {ComponentProps} from 'react';

import {BrandTag} from '@/modules/commerce/brand/BrandTag';
import type {BrandTagFragment} from '@/modules/commerce/brand/query';
import {cn} from '@/modules/foundation/shared/tailwind';

type Props = ComponentProps<'div'> & {
	brands: BrandTagFragment[];
};

export default function ProductBrandTags({brands, className, children, ...rest}: Props) {
	return (
		<div className={cn('flex flex-wrap gap-2', className)} {...rest}>
			{children}
			{brands.map((brand) => (
				<BrandTag key={brand._id} brand={brand} />
			))}
		</div>
	);
}
